export const OFFPLAN_REGISTRATION_ERROR = 'OFFPLAN_REGISTRATION_ERROR';
export const OFFPLAN_REGISTRATION_LOADING = 'OFFPLAN_REGISTRATION_LOADING';
export const INITIATE_OFFPLAN_REGISTRATION_APPLICATION_SUCCESS = 'INITIATE_OFFPLAN_REGISTRATION_APPLICATION_SUCCESS';
export const FETCH_APPLICATION_OFFPLAN_REGISTRATION_SUCCESS = 'FETCH_APPLICATION_OFFPLAN_REGISTRATION_SUCCESS';
export const FETCH_DOCUMENTS_OFFPLAN_REGISTRATION_SUCCESS = 'FETCH_DOCUMENTS_OFFPLAN_REGISTRATION_SUCCESS';
export const SAVE_APPLICATION_OFFPLAN_REGISTRATION_SUCCESS = 'SAVE_APPLICATION_OFFPLAN_REGISTRATION_SUCCESS';
export const CHANGE_OFFPLAN_REGISTRATION_STEP = 'CHANGE_OFFPLAN_REGISTRATION_STEP';
export const OFFPLAN_REGISTRATION_CLEAR_DATA = 'OFFPLAN_REGISTRATION_CLEAR_DATA';
export const DOWNLOAD_DOCUMENT_OFFPLAN_REGISTRATION_SUCCESS = 'DOWNLOAD_DOCUMENT_OFFPLAN_REGISTRATION_SUCCESS';
export const ADD_TO_ERROR_INITITATE = 'ADD_TO_ERROR_INITITATE';
export const CHECKOUT_OFFPLAN_REGISTRATION_APPLICATION = 'CHECKOUT_OFFPLAN_REGISTRATION_APPLICATION';
export const CHECKOUT_OFFPLAN_REGISTRATION_APPLICATION_SUCCESS = 'CHECKOUT_OFFPLAN_REGISTRATION_APPLICATION_SUCCESS';
export const OFFPLAN_REGISTRATION_CANCEL_APPLICATION_SUCCESS = 'OFFPLAN_REGISTRATION_CANCEL_APPLICATION_SUCCESS';
export const APPROVAL_OFFPLAN_REGISTRATION_SUCCESS = 'APPROVAL_OFFPLAN_REGISTRATION_SUCCESS';
export const POST_RETURN_OFFPLAN_REGISTRATION_SUCCESS = 'POST_RETURN_OFFPLAN_REGISTRATION_SUCCESS';
export const OFFPLAN_REGISTRATION_PAYMENT_BREAKDOWN_SUCCESS = 'OFFPLAN_REGISTRATION_PAYMENT_BREAKDOWN_SUCCESS';
export const OFFPLAN_REGISTRATION_PROPERTY_DOCUMENTS_SUCCESS = 'OFFPLAN_REGISTRATION_PROPERTY_DOCUMENTS_SUCCESS';
export const DOWNLOAD_OFFPLAN_REGISTRATION_CONTRACT_DOCUMENT_SUCCESS =
  'DOWNLOAD_OFFPLAN_REGISTRATION_CONTRACT_DOCUMENT_SUCCESS';
export const UPLOAD_OFFPLAN_REGISTRATION_DOCUMENT_SUCCESS = 'UPLOAD_OFFPLAN_REGISTRATION_DOCUMENT_SUCCESS';
export const FETCH_OFFPLAN_REGISTRATION_PROPERTY_CONTRACT_SUCCESS =
  'FETCH_OFFPLAN_REGISTRATION_PROPERTY_CONTRACT_SUCCESS';
export const UPDATE_PROJECT_DETAILS = 'UPDATE_PROJECT_DETAILS';
export const UPDATE_SERVEYING_CONSULTANT_DETAILS = 'UPDATE_SERVEYING_CONSULTANT_DETAILS';

export const SAVE_APPLICATION_SURVEYING_CONSULTANT_SUCCESS = 'SAVE_APPLICATION_SURVEYING_CONSULTANT_SUCCESS';

export const OFFPLAN_REGISTRATION_ADD_PLOTS_SUCCESS = 'OFFPLAN_REGISTRATION_ADD_PLOTS_SUCCESS';
export const OFFPLAN_REGISTRATION_REMOVE_PLOTS_SUCCESS = 'OFFPLAN_REGISTRATION_REMOVE_PLOTS_SUCCESS';
export const OFFPLAN_REGISTRATION_UPLOAD_PLOTS_SUCCESS = 'OFFPLAN_REGISTRATION_UPLOAD_PLOTS_SUCCESS';
export const OFFPLAN_REGISTRATION_FETCH_PLOTS_SUCCESS = 'OFFPLAN_REGISTRATION_FETCH_PLOTS_SUCCESS';
export const OFFPLAN_REGISTRATION_REMOVE_INVALID_PLOTS_SUCCESS = 'OFFPLAN_REGISTRATION_REMOVE_INVALID_PLOTS_SUCCESS';
export const OFFPLAN_REGISTRATION_CLEAR_PLOTS_TYPE = 'OFFPLAN_REGISTRATION_CLEAR_PLOTS_TYPE';

export const FETCH_DEVELOPERS_SUCCESS = 'FETCH_DEVELOPERS_SUCCESS';
export const FETCH_DEVELOPER_PROJECTS_SUCCESS = 'FETCH_DEVELOPER_PROJECTS_SUCCESS';
export const FETCH_DEVELOPER_PROJECTS_FAILURE = 'FETCH_DEVELOPER_PROJECTS_FAILURE';

export const FETCH_SURVEYORS_LIST_SUCCESS = 'FETCH_SURVEYORS_LIST_SUCCESS';
export const FETCH_SURVEYORS_LIST_FAILURE = 'FETCH_SURVEYORS_LIST_FAILURE';

export const SET_SURVEYOR_SUCCESS = 'SET_SURVEYOR_SUCCESS';
export const SET_SURVEYOR_FAILURE = 'SET_SURVEYOR_FAILURE';

export const FETCH_IMAGES_SUCCESS = 'FETCH_IMAGES_SUCCESS';
export const FETCH_IMAGES_FAILURE = 'FETCH_IMAGES_FAILURE';

export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILURE = 'UPLOAD_IMAGE_FAILURE';

export const MARK_IMAGE_SUCCESS = 'MARK_IMAGE_SUCCESS';
export const MARK_IMAGE_FAILURE = 'MARK_IMAGE_FAILURE';

export const DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS';
export const DELETE_IMAGE_FAILURE = 'DELETE_IMAGE_FAILURE';

export const FETCH_PROPERTIES_INFORMATION = 'FETCH_PROPERTIES_INFORMATION';
export const FETCH_PROPERTIES_INFORMATION_SUCCESS = 'FETCH_PROPERTIES_INFORMATION_SUCCESS';

export const CLEAR_PLOTS_NOTIFICATION = 'CLEAR_PLOTS_NOTIFICATION';

export const PROJECT_INVENTORY_SHEET_ERROR = 'PROJECT_INVENTORY_SHEET_ERROR';
export const TOGGLE_INVENTORY_SHEET_MODAL = 'TOGGLE_INVENTORY_SHEET_MODAL';
export const TOGGLE_RETURN_MODAL = 'TOGGLE_RETURN_MODAL';
